import { ClientEvent } from '@udemy/event-tracking';
export const ACTIONS = {
  openSelector: 'open_selector',
  selectLanguage: 'select_language'
};
export const SELECTOR_LOCATIONS = {
  desktopHeader: 'desktop_header',
  mobileNav: 'mobile_nav',
  footer: 'footer',
  orgInvitation: 'org_invitation_verification',
  orgOnboardingHeader: 'org_onboarding_header',
  orgLogin: 'org_login'
};
export class LanguageSelectorActionEvent extends ClientEvent {
  constructor({
    action,
    selectorLocation,
    selectedLocale = null
  }) {
    super('LanguageSelectorActionEvent');
    this.action = void 0;
    this.selectorLocation = void 0;
    this.selectedLocale = void 0;
    this.action = action;
    this.selectorLocation = selectorLocation;
    this.selectedLocale = selectedLocale;
  }
}
//# sourceMappingURL=events.js.map